import {
  APIFailureAction,
  APIRequestAction,
  APISuccessAction,
  NormalizedError,
  NormalizedResponse,
} from '../../../types';
import {
  PRODUCTS_FETCH_API_FAILURE,
  PRODUCTS_FETCH_API_REQUEST,
  PRODUCTS_FETCH_API_SUCCESS,
  PRODUCTS_FETCH_TRIGGER,
} from '../constants';
import { ProductsSortOrder, ProductsType } from '../types';

// action types

type ProductsFetchPayload = {
  sort: ProductsSortOrder;
  start: number;
  search: string;
  type: ProductsType;
};

export interface ProductsFetchNormalizedResponse extends NormalizedResponse {
  readonly result: {
    count: number;
    ids: number[];
    allProductIds: number[];
    briefProductVersions: number[];
  };
}

export interface ProductsFetchApiRequestAction extends APIRequestAction {
  type: typeof PRODUCTS_FETCH_API_REQUEST;
  payload: ProductsFetchPayload;
}

export type ProductsFetchTriggerAction = {
  type: typeof PRODUCTS_FETCH_TRIGGER;
  payload: ProductsFetchPayload;
};

export interface ProductsFetchApiSuccessAction extends APISuccessAction {
  type: typeof PRODUCTS_FETCH_API_SUCCESS;
  payload: ProductsFetchPayload & {
    response: ProductsFetchNormalizedResponse;
  };
}

export interface ProductsFetchApiFailureAction extends APIFailureAction {
  type: typeof PRODUCTS_FETCH_API_FAILURE;
  payload: ProductsFetchPayload & {
    error: NormalizedError;
  };
}

// action creators

export const productsFetchTrigger = (
  sort: ProductsSortOrder,
  start: number,
  search: string,
  type: ProductsType
): ProductsFetchTriggerAction => ({
  type: PRODUCTS_FETCH_TRIGGER,
  payload: {
    search,
    sort,
    start,
    type,
  },
});

export const productsFetchApiRequest = (
  sort: ProductsSortOrder,
  start: number,
  search: string,
  type: ProductsType
): ProductsFetchApiRequestAction => ({
  type: PRODUCTS_FETCH_API_REQUEST,
  payload: { search, sort, start, type },
});

export const productsFetchApiSuccess = (
  sort: ProductsSortOrder,
  start: number,
  search: string,
  type: ProductsType,
  response: ProductsFetchNormalizedResponse
): ProductsFetchApiSuccessAction => ({
  type: PRODUCTS_FETCH_API_SUCCESS,
  payload: { response, search, sort, start, type },
});

export const productsFetchApiFailure = (
  sort: ProductsSortOrder,
  start: number,
  search: string,
  type: ProductsType,
  error: NormalizedError
): ProductsFetchApiFailureAction => ({
  type: PRODUCTS_FETCH_API_FAILURE,
  payload: { error, search, sort, start, type },
});
